import React, { memo, useState } from "react";
import { Badge, Col, Nav, Row, Tab } from "react-bootstrap";
import { PropTypes } from "prop-types";
import { TabData03 } from "./TabData";
import axios from "axios";
import config from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Fonction utilitaire pour diviser un tableau en groupes de n éléments
const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const ShoppingCartIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

const Tab03 = (props) => {
  // Diviser les données en groupes de 6
  const navChunks = chunkArray(props.data, 6);
  // État pour gérer le chargement de l'ajout au panier
  const [isAdding, setIsAdding] = useState({});

  // Fonction pour ajouter une story au panier
  const handleAddToBasket = async (productId) => {
    if (isAdding[productId]) return; // Éviter les clics multiples

    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("Veuillez vous connecter pour ajouter au panier");
      return;
    }

    setIsAdding((prev) => ({ ...prev, [productId]: true }));

    try {
      const response = await axios.post(
        `${config.REACT_APP_API_URL}/add-to-basket`,
        { productId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-api-key': config.SITE_API_KEY
          },
        }
      );
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur lors de l'ajout au panier");
    } finally {
      setIsAdding((prev) => ({ ...prev, [productId]: false }));
    }
  };

  return (
    <>
      <ToastContainer position="bottom-left" />
      <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
        <Row className="tab-style-03 justify-center">
          <Col lg={12} className="text-center">
            {/* Rendre chaque groupe de 6 onglets dans une Row */}
            {navChunks.map((chunk, chunkIndex) => (
              <Row key={chunkIndex} className="justify-center mb-4">
                {chunk.map((item, i) => (
                  <Col key={i} xs={12} sm={6} md={4} lg={2} className="text-2xl text-center">
                    <Nav.Item>
                      <Nav.Link
                        className="text-center w-[105%]"
                        eventKey={chunkIndex * 6 + i} // Calculer l'index global
                      >
                        {item.tabTitle}
                      </Nav.Link>
                    </Nav.Item>
                  </Col>
                ))}
              </Row>
            ))}
          </Col>
          <Col>
            <Tab.Content>
              {props.data.map((item, i) => (
                <Tab.Pane eventKey={i} key={i}>
                  <Row xs={2}>
                    {item.activities.map((activity, j) => (
                      <Col key={j} lg={6} xs={12} className="tab-item">
                        <div className="border-b border-[#0000001a] flex py-[28px] md:items-center">
                          
                          {activity.img === '/picture/product/' ? (
                    <img
                      style={{
                        boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)"
                      }}
                            height={73}
                            width={73}
                            className=" mr-[25px] xs:w-[40px] xs:mr-[20px]"
                            src="/img/product.jpg"
                            alt={activity.title}
                            data-no-retina=""
                          />
                  ): 
                    
                    (
                    <img
                      style={{
                        boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.5)"
                      }}
                            height={73}
                            width={73}
                            className=" mr-[25px] xs:w-[40px] xs:mr-[20px]"
                            src={`${config.REACT_APP_API_URL}${activity.img}`}
                            alt={activity.title}
                            data-no-retina=""
                          />
                          )}
                                                
                          <div className="w-[70%] lg:w-[65%] xs:w-[60%] xs:mr-[10px]">
                            <span className="font-bold text-xmd text-darkgray leading-[28px]">
                              {activity.title}
                              {activity.badge && (
                                <Badge
                                  style={{ backgroundColor: activity.badge.color }}
                                  className="inline-block align-middle py-[2px] px-[9px] text-[10px] leading-[15px] text-white uppercase ml-[10px] rounded-[1px] font-medium"
                                >
                                  {activity.badge.title}
                                </Badge>
                              )}
                            </span>
                            <p>{activity.content.substr(0, 70) + " ...."}</p>
                          </div>
                        <button
                            onClick={(e) => {
                              e.preventDefault();
                              handleAddToBasket(activity._id);
                            }}
                          className="h-0 flex items-center gap-2 px-3 py-4 my-auto bg-emerald-600 hover:bg-[#87c03d] text-white font-medium rounded-lg transition-colors shadow-sm"
                        >
                          <ShoppingCartIcon className="w-4 h-4" />
                        </button>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  );
};

Tab03.defaultProps = {
  data: TabData03,
};

Tab03.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.exact({
      tabTitle: PropTypes.string,
      day: PropTypes.string,
      tabicons: PropTypes.string,
      activities: PropTypes.arrayOf(
        PropTypes.exact({
          time: PropTypes.string,
          price: PropTypes.string,
          img: PropTypes.string,
          title: PropTypes.string,
          content: PropTypes.string,
          author: PropTypes.string,
          _id: PropTypes.string, // Ajout de _id pour correspondre à l'API
          badge: PropTypes.exact({
            title: PropTypes.string,
            color: PropTypes.string,
          }),
        })
      ),
    })
  ),
};

export default memo(Tab03);